const TOKEN_KEY = 'njja_video_token'
const USER_KEY = 'njja_video_user'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || ''
}

export function setToken(token) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token)
  } else {
    localStorage.removeItem(TOKEN_KEY)
  }
}

export function getUsername() {
  return localStorage.getItem(USER_KEY) || ''
}

export function setUsername(username) {
  if (username) {
    localStorage.setItem(USER_KEY, username)
  } else {
    localStorage.removeItem(USER_KEY)
  }
}

export function clearAuth() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
}

export function isLoggedIn() {
  return !!getToken()
}
